import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Widget, fromJSX } from 'widgets-for-react'
import { styleguideAbout } from './pages/about.mod'
import { styleguideComponents } from './pages/components.mod'
import { styleguideCompositions } from './pages/compositions.mod'
import { styleguideGuidelines } from './pages/guidelines.mod'
import { styleguideObjects } from './pages/objects.mod'
import { styleguideTokens } from './pages/tokens.mod'

// IMPORT STYLING - DO NOT REMOVE
import '../styling/styleguide/stylesheets/styleguide.scss'

export type StyleguideState = {
  page: 'about' | 'guidelines' | 'tokens' | 'objects' | 'components' | 'compositions'
}

const splitHash = () => {
  return window.location.hash.split('#')[1].split('-')[0]
}

const $breakpoint = 768

export let currentPage = window.location.hash ? splitHash() : 'about'
const apply_token_to_url = (token: string): void => {
  let address: string = window.location.href
  if (address.endsWith('/')) {
    address = address.slice(0, address.length - 1)
  }
  const tmp = address.split('#')
  window.location.href = tmp[0] + '#' + token
}
const __ = () => null

export const styleguide: Widget<never> = fromJSX(() => (
  <>
    <article className="styleguide">
      <div className="styleguide__main">
        <header className="styleguide__header">
          <div className="styleguide__brand styleguide--styled">
            <a className="styleguide__logo-link" href="/styleguide">
              <h1 className="sr-text">Styleguide Refresco</h1>
              <img
                className="header__logo logo"
                src="/images/logo-new-refresco.svg"
                alt="Refresco logo"
                width="227"
                height="77"
              />
              <span className="styleguide__subtitle" aria-hidden="true">
                Styleguide
              </span>
            </a>

            <button
              className="styleguide-toggler"
              onClick={() => document.documentElement.classList.toggle('styleguide-nav--toggled')}
            >
              <span className="sr-text">Toggle Menu</span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </button>
          </div>

          <div className="styleguide-nav__wrapper styleguide--styled" data-active-page={currentPage}>
            <nav className="styleguide-nav">
              <h2 className="sr-text">Menu</h2>

              <ul className="styleguide-nav__list">
                <li className="styleguide-nav__item styleguide-nav--about">
                  <button
                    className="styleguide-nav__link"
                    onClick={() => {
                      return [
                        (currentPage = 'about'),
                        window.innerWidth < $breakpoint &&
                          document.documentElement.classList.remove('styleguide-nav--toggled')
                      ]
                    }}
                  >
                    About
                  </button>
                </li>
                <li className="styleguide-nav__item styleguide-nav--tokens">
                  <button
                    className="styleguide-nav__link styleguide-nav__toggler"
                    onClick={() => [
                      (currentPage = 'tokens'),
                      document.documentElement.classList.toggle('styleguide-tokens--toggled')
                    ]}
                  >
                    Design Tokens
                  </button>
                  <ul className="styleguide-nav__sublist">
                    {StyleguideItem('Colors', 'tokens', 'tokens-colors')}
                    {StyleguideItem('Fonts', 'tokens', 'tokens-fonts')}
                    {StyleguideItem('Font Styles', 'tokens', 'tokens-styles')}
                    {StyleguideItem('Font Sizes & Line Heights', 'tokens', 'tokens-sizes-heights')}
                    {StyleguideItem('Icons', 'tokens', 'tokens-icons')}
                    {StyleguideItem('Widths', 'tokens', 'tokens-widths')}
                    {StyleguideItem('Spacings & Gutters', 'tokens', 'tokens-spacings-gutters')}
                    {StyleguideItem('Transitions', 'tokens', 'tokens-transitions')}
                  </ul>
                </li>

                <li className="styleguide-nav__item styleguide-nav--objects">
                  <button
                    className="styleguide-nav__link styleguide-nav__toggler"
                    onClick={() => [
                      (currentPage = 'objects'),
                      document.documentElement.classList.toggle('styleguide-objects--toggled')
                    ]}
                  >
                    Design Objects
                  </button>

                  <ul className="styleguide-nav__sublist">
                    {StyleguideItem('Typography', 'objects', 'objects-typography')}
                    {StyleguideItem('Buttons', 'objects', 'objects-buttons')}
                    {StyleguideItem('Links', 'objects', 'objects-links')}
                    {StyleguideItem('Lists', 'objects', 'objects-lists')}
                    {StyleguideItem('Pagination', 'objects', 'objects-pagination')}
                  </ul>
                </li>
                <li className="styleguide-nav__item styleguide-nav--components">
                  <button
                    className="styleguide-nav__link styleguide-nav__toggler"
                    onClick={() => [
                      (currentPage = 'components'),
                      document.documentElement.classList.toggle('styleguide-components--toggled')
                    ]}
                  >
                    Design Components
                  </button>

                  <ul className="styleguide-nav__sublist">
                    {StyleguideItem('Apply Block', 'components', 'components-apply')}
                    {StyleguideItem('CTA Block', 'components', 'components-cta')}
                    {StyleguideItem('Colored background', 'components', 'components-blocks-color')}
                    {StyleguideItem('Download Block', 'components', 'components-download')}
                    {StyleguideItem('Expand Block', 'components', 'components-expand')}
                    {StyleguideItem('Featured Content', 'components', 'components-featured-content')}
                    {StyleguideItem('Footer', 'components', 'components-footer')}
                    {StyleguideItem('Image gallery block', 'components', 'components-gallery')}
                    {StyleguideItem('Image with Expandables Block ', 'components', 'components-image-expand')}
                    {StyleguideItem('Latest updates', 'components', 'components-updates')}
                    {StyleguideItem('Link Grid Block', 'components', 'components-linkgrid')}
                    {StyleguideItem('Link List Block', 'components', 'components-links')}
                    {StyleguideItem('Media Block', 'components', 'components-media')}
                    {StyleguideItem('Press Release Block', 'components', 'components-releases')}
                    {StyleguideItem('Cards Block', 'components', 'components-cards')}
                    {StyleguideItem('Quote Block', 'components', 'components-quote')}
                    {StyleguideItem('Reports Block', 'components', 'components-reports')}
                    {StyleguideItem('Recruitment Process Block', 'components', 'components-recruit')}
                    {StyleguideItem('Spacer (custom)', 'components', 'components-spacer')}
                    {StyleguideItem('Stories Grid Block', 'components', 'components-stories')}
                    {StyleguideItem('Text Block', 'components', 'components-text')}
                    {StyleguideItem('Text + Image Block', 'components', 'components-text-image')}
                    {StyleguideItem('Timeline Block', 'components', 'components-timeline')}
                  </ul>
                </li>
                <li className="styleguide-nav__item styleguide-nav--compositions">
                  <button
                    className="styleguide-nav__link styleguide-nav__toggler"
                    onClick={() => [
                      (currentPage = 'compositions'),
                      document.documentElement.classList.toggle('styleguide-compositions--toggled')
                    ]}
                  >
                    Design Compositions
                  </button>

                  <ul className="styleguide-nav__sublist">
                    {StyleguideItem(
                      'Vacancy - Detail page and overview',
                      'compositions',
                      'compositions-vacancy-detail'
                    )}
                    {StyleguideItem('Vacancy - Landing', 'compositions', 'compositions-vacancy-landing')}
                  </ul>
                </li>
              </ul>
            </nav>

            <div className="styleguide__extra styleguide--styled">
              <a className="styleguide__extra-link" href="https://www.hoppinger.com">
                by Hoppinger
              </a>
            </div>
          </div>
        </header>

        <div className="styleguide__content">
          {currentPage == 'about'
            ? styleguideAbout.run(__)
            : currentPage == 'guidelines'
            ? styleguideGuidelines.run(__)
            : currentPage == 'tokens'
            ? styleguideTokens.run(__)
            : currentPage == 'objects'
            ? styleguideObjects.run(__)
            : currentPage == 'components'
            ? styleguideComponents.run(__)
            : currentPage == 'compositions'
            ? styleguideCompositions.run(__)
            : null}
        </div>
      </div>

      <svg xmlns="https://www.w3.org/2000/svg" style={{ display: 'none' }} aria-hidden="true">
        <symbol id="image--logo" viewBox="0 0 120 32">
          <path d="m27.5 7.2c0-1.2.9-2.1 2.1-2.1s2.1.9 2.1 2.1-.9 2.1-2.1 2.1c-1.1-.1-2.1-1-2.1-2.1z" />
          <path d="m32.8 8.3c0-.9.7-1.6 1.6-1.6s1.6.7 1.6 1.6-.7 1.6-1.6 1.6-1.6-.8-1.6-1.6z" />
          <path d="m27 4.4-2.1-2.1 2.1-1.7 2.1 1.7z" />
          <path d="m26.4 7.2c0-1.2-.9-2.1-2.1-2.1s-2.1.9-2.1 2.1.9 2.1 2.1 2.1c1.2-.1 2.1-1 2.1-2.1z" />
          <path d="m21.2 8.3c0-.9-.7-1.6-1.6-1.6s-1.6.7-1.6 1.6.7 1.6 1.6 1.6 1.6-.8 1.6-1.6z" />
          <path d="m19.7 11.6c2.4-.5 4.9-.8 7.3-.8 2.5 0 4.9.3 7.3.8v2c-2.4-.4-4.9-.6-7.3-.6s-4.9.2-7.3.6z" />
          <path d="m2.9 24.6h1.5c1.6 0 2.9.7 2.9 2.4 0 1.6-1.2 2.5-2.9 2.5h-1.5zm1.9 6.7c3.5 0 5.6-1.8 5.6-4.3-.1-2-1.8-3.6-3.8-3.6 1.7-.4 2.9-1.8 2.9-3.6 0-2-1.7-3.1-4.2-3.1h-5.3v14.6zm-1.9-12.8h1.5c1.3 0 2.2.6 2.2 1.9-.1 1.4-1.3 2.5-2.7 2.5h-.1-.9z" />
          <path d="m18.9 29.4c-3.1 0-4.2-2.9-4.2-5.7 0-2.7 1.2-5.3 4.2-5.3 2.9 0 4.1 2.6 4.1 5.3.1 2.9-1 5.7-4.1 5.7m0 2.1c4.5 0 7.3-3.4 7.3-7.8.1-4-3.1-7.3-7-7.3-.1 0-.2 0-.3 0-4-.1-7.2 3.1-7.3 7.1v.3c0 4.3 2.8 7.7 7.3 7.7" />
          <path d="m35 29.4c-3.1 0-4.2-2.9-4.2-5.7 0-2.7 1.2-5.3 4.2-5.3 2.9 0 4.2 2.6 4.2 5.3 0 2.9-1.1 5.7-4.2 5.7m0 2.1c4.5 0 7.3-3.4 7.3-7.8 0-4-3.2-7.3-7.2-7.3s-7.3 3.2-7.3 7.2v.1c0 4.4 2.8 7.8 7.2 7.8" />
          <path d="m57.1 31.3h-2.1c-2.8-3.4-5.6-6.7-8.4-10.5v10.5h-2.4v-14.6h2.1c2.8 3.3 5.6 6.7 8.4 10.4v-10.4h2.4z" />
          <path d="m72.7 18.6h-5.8v4h4.8v2h-4.8v4.7h5.8v2h-8.8v-14.6h8.8z" />
          <path d="m77.8 18.6h2.2c3.1 0 4.9 1.9 4.9 4.9 0 4.1-1.8 5.8-5.2 5.8h-1.8zm-2.9-1.9v14.6h4.8c5.2 0 8.3-2.9 8.3-7.7 0-3.5-2.1-6.9-8-6.9z" />
          <path d="m92.6 25.3c.7-1.9 1.4-3.7 2-6 .7 2.3 1.3 4 1.9 6zm1.1-8.8-6 14.6h2.5l1.5-4h5.3l1.4 4h3.3l-5.5-14.6z" />
          <path d="m119.9 31.3h-2.9v-11.4c-1.6 4.1-3.3 7.7-5 11.4h-1.6c-1.6-3.7-3.2-7.3-4.7-11.4v11.4h-2.4v-14.6h3.6c1.5 3.6 3.9 9.3 4.5 11.2.7-2 3.3-7.6 5-11.2h3.4z" />
        </symbol>

        <symbol id="icon--linkedin" viewBox="0 0 20 20">
          <path d="M14.67354,12.21317a2.20436,2.20436,0,0,0-2.07428-2.26562,1.83419,1.83419,0,0,0-2.06372,1.05674,3.60077,3.60077,0,0,0-.19536,1.04414v5.45586H7.68729V7.15624h2.75483l0.13589,1.348h0.05947A3.26232,3.26232,0,0,1,13.57,7.15624c1.988,0,3.77017,1.57358,3.77017,4.458v5.89007H14.67354V12.21317ZM4.11531,5.92645a1.35315,1.35315,0,0,1-1.4261-1.276q-0.00269-.04843-0.0019-0.097A1.364,1.364,0,0,1,4.03766,3.17592q0.05669-.00056.11328,0.00358a1.359,1.359,0,0,1,1.44345,1.269q0.00337,0.05238.00269,0.10491a1.36882,1.36882,0,0,1-1.36,1.37763Q4.17615,5.93148,4.11531,5.92645ZM3.00687,17.50428V7.15624h2.3294v10.348H3.00687v0Z" />
        </symbol>

        <symbol id="icon--twitter" viewBox="0 0 20 20">
          <path d="M17.55338,4.49426a5.60041,5.60041,0,0,0,2.19036-.60044s-0.15034.54692-2.03123,2.27737c0,0,.63329,9.33715-9.01632,11.6239,0,0-4.89373,1.061-8.43993-1.64547,0,0,3.71228.67039,5.80086-1.67411a3.79994,3.79994,0,0,1-3.5462-2.76185,3.18669,3.18669,0,0,0,1.62184-.05587A3.928,3.928,0,0,1,1.1361,7.63966,2.53079,2.53079,0,0,0,2.70289,8.142s-2.7487-2.37221-1.04452-5.32889c0,0,3.68313,4.42,8.248,4.15756A4.05517,4.05517,0,0,1,9.78378,5.9801,3.95224,3.95224,0,0,1,13.70649,2a3.88474,3.88474,0,0,1,2.79635,1.18915,4.44628,4.44628,0,0,0,2.66683-.86428C19.16967,2.32534,19.23119,3.17647,17.55338,4.49426Z" />
        </symbol>

        <symbol id="icon--youtube" viewBox="0 0 20 20">
          <path d="M18.5,12.9753a3.17755,3.17755,0,0,1-3.16279,3.17365H4.66279A3.17755,3.17755,0,0,1,1.5,12.9753V7.02471A3.17755,3.17755,0,0,1,4.66279,3.85107H15.33721A3.17755,3.17755,0,0,1,18.5,7.02471V12.9753ZM8.01064,7.24583v5.87006l5.01136-2.9346Z" />
        </symbol>
      </svg>
    </article>
  </>
))

// Close styleguide menu when pressing the escape key
window.addEventListener('keyup', (e) => {
  if (e.keyCode === 27) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})

// Close styleguide menu when clicking outside of styleguide header/menu
document.documentElement.addEventListener('click', (e) => {
  const target: HTMLElement = (e.target as HTMLElement) || (e.currentTarget as HTMLElement)

  if (
    target.closest('.styleguide__header') === null &&
    document.documentElement.classList.contains('styleguide-nav--toggled')
  ) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})

export const styleguide_to = () => {
  const root = createRoot(document.getElementById('react-content'))
  root.render(styleguide.run(() => {}))
}

const StyleguideItem = (label: string, page: string, token: string) => {
  return (
    <li className="styleguide-nav__item">
      <button
        className="styleguide-nav__link"
        onClick={() => [
          (currentPage = page),
          window.innerWidth < $breakpoint && document.documentElement.classList.remove('styleguide-nav--toggled'),
          apply_token_to_url(token)
        ]}
      >
        {label}
      </button>
    </li>
  )
}
